import { render, staticRenderFns } from "./citationPush.vue?vue&type=template&id=2537ad7c&scoped=true"
import script from "./citationPush.vue?vue&type=script&lang=js"
export * from "./citationPush.vue?vue&type=script&lang=js"
import style0 from "./citationPush.vue?vue&type=style&index=0&id=2537ad7c&prod&lang=scss"
import style1 from "./citationPush.vue?vue&type=style&index=1&id=2537ad7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2537ad7c",
  null
  
)

export default component.exports